import {SpanIcon} from '@mazraeapp/react_icon_kit';
import cn from 'classnames';

interface IRateStarBadge {
  rate: number;
  propsClass?: string;
}

/**
 * Renders a rate star badge component with a rounded background, centered content, and a star icon.
 *
 * @param {IRateStarBadge} props - The component props.
 * @param {number} props.rate - The rating value to display.
 * @param {string} [props.propsClass] - An optional tailwind class to apply to the wrapper element.
 * @returns {JSX.Element} The rendered rate star badge component.
 */
const RateStarBadge = ({rate, propsClass}: IRateStarBadge): JSX.Element => {
  return (
    <div
      className={cn(
        'flex rounded-[50px] min-w-[40px] h-[24px] justify-center py-1 px-1.5 gap-0.5 items-center bg-gray-50',
        propsClass,
      )}
    >
      <SpanIcon className="icon-nameStar text-[#F2AE24] text-[14px]" />
      <span className="text-md">{rate.toFixed(1)}</span>
    </div>
  );
};

export default RateStarBadge;
